import {ReactElement} from "react";
import {Button, Card, Col, DatePicker, Form, FormInstance, Input, Typography} from "antd";
import IInstance from "../../interfaces/IInstance";
import {DeleteOutlined} from "@ant-design/icons";
import * as dayjs from "dayjs";
import {useTranslate} from "@refinedev/core";
//@ts-ignore
import {v4 as uuidv4} from 'uuid';
import {Custom} from "../../utils/refineUtils";
import IActivity from "../../interfaces/IActivity";

interface IProps {
    activity?: IActivity,
    instance?: IInstance,
    index?: number
    form?: FormInstance<{}>,
    editable?: boolean,
    span?: number,
    style?: any,
    onClick?: () => void,
    onDelete?: (index: number) => void
}

const {Text} = Typography;

export default function InstanceCard(props: IProps): ReactElement | null {
    const translate = useTranslate();
    const handleStartDateChange = (date: string | number | Date | dayjs.Dayjs | null | undefined) => {
        const endDate = dayjs(date).add(props.activity?.duration ?? 0, 'minute');
        props.form?.setFieldValue(['activities', props.index ?? 0, 'end'], endDate.isValid() ? endDate : null);
    };
    const datePickerProps = {
        style: {width: "100%"},
        showTime: {format: 'HH:mm', hideDisabledOptions: true},
        showSecond: false,
        format: translate('instance.date'),
        disabledTime: () => ({
            disabledMinutes: () => Array.from({length: 61}, (_, i) => i).filter(x => x % 5 !== 0)
        })
    }

    const DeleteActivityButton = () => (
        <Button key={uuidv4()} size="small" onClick={() => props.onDelete && props.onDelete(props?.index ?? 0)}
                icon={<DeleteOutlined/>}/>
    )

    const CardTitle = () => (
        <Text>{props.editable ? translate('instance.meta.new') : (props?.instance?.title ?? translate('instance.noTitle'))}</Text>
    )

    return (
        <Col span={props.span ?? 8}>
            <Card onClick={props?.onClick} type="inner" title={<CardTitle/>} size="small" style={props?.style}
                  extra={props?.editable && <DeleteActivityButton/>}>
                {props?.editable
                    ?
                    <>
                        <Custom.Item name={[props.index ?? 0, "title"]} label="instance.title"><Input/></Custom.Item>
                        <Custom.Item name={[props.index ?? 0, "tutor"]} label="instance.tutor"><Input/></Custom.Item>
                        <Custom.Item name={[props.index ?? 0, "start"]} label="instance.start">
                            <DatePicker {...datePickerProps} onChange={handleStartDateChange}/>
                        </Custom.Item>
                        <Custom.Item name={[props.index ?? 0, "end"]} label="instance.end">
                            <DatePicker {...datePickerProps}/>
                        </Custom.Item>
                    </>
                    :
                    <>
                        <Custom.IconInfo label="instance.tutor" icon={null}
                                         value={props?.instance?.tutor ?? translate('instance.noTutor')}/>
                        <Custom.IconInfo label="instance.start" icon={null}
                                         value={dayjs(props?.instance?.start).format("DD/MM/YYYY HH:mm:ss")}/>
                        <Custom.IconInfo label="instance.end" icon={null}
                                         value={dayjs(props?.instance?.end).format("DD/MM/YYYY HH:mm:ss")}/>
                        <Custom.IconInfo label="instance.users" icon={null}
                                         value={'' + (props?.instance?.users?.length ?? 0)}/>
                    </>
                }
            </Card>
        </Col>
    );
}
